import { REDUCER_KEY_RS } from '@Pages/RetroSynthesis/RetroSynthesisProjects/constants';
import { REDUCER_KEY_RS_DRAW_STRUCTURE } from '@Pages/RetroSynthesis/DrawStructure/constants';

export const rsState = (state) => state && state.get && state.get(REDUCER_KEY_RS);
export const drawStructure = (state) => rsState(state).get(REDUCER_KEY_RS_DRAW_STRUCTURE);
export const editorType = (state) => drawStructure(state).editorType;
export const isLoading = (state) => drawStructure(state).isLoading;
